module.exports = __webpack_public_path__ + "stylesheets/settings_c9a127c21ce84904d302d94c849450d4.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/settings.less
// module id = NGqW
// module chunks = 154